import gql from 'graphql-tag';

import { CHANGE_EVENT_ANSWER_FRAGMENT } from '../Answer/changeEventAnswer';
import { CHANGE_EVENT_COMMENT_FRAGMENT } from '../Comment/changeEventComment';
import { CHANGE_EVENT_POST_DETAILS_FRAGMENT } from '../Post/changeEventPostDetails';
import { CHANGE_EVENT_QUESTION_OVERVIEW_FRAGMENT } from '../Question/changeEventQuestionOverview';

export const CHANGE_EVENT_FRAGMENT = gql`
  fragment changeEvent on ChangeEvent {
    id
    author {
      id
      name
      picture
      email
      jobTitle
    }
    plex {
      id
      name
      color
    }
    createdAt
    eventType
    targetType
    eventTarget {
      ... on ChangeEventTargetBoard {
        board {
          id
          name
          faqCount(filterPublishStatus: ALL, labelIds: [])
        }
      }
      ... on ChangeEventTargetPost {
        post {
          ...changeEventPostDetails
        }
      }
      ... on ChangeEventTargetEvent {
        event {
          ...changeEventPostDetails
        }
      }
      ... on ChangeEventTargetQuestion {
        question {
          ...changeEventQuestionOverview
        }
      }
      ... on ChangeEventTargetAnswer {
        answer {
          ...changeEventAnswer
        }
      }
      ... on ChangeEventTargetComment {
        comment {
          post {
            ...changeEventPostDetails
          }
          question {
            ...changeEventQuestionOverview
          }
          ...changeEventComment
        }
      }
    }
    updateDeltaBefore {
      v1 {
        post {
          mentions
        }
        question {
          acceptedAnswerId
        }
        answer {
          mentions
        }
      }
    }
    updateDeltaAfter {
      v1 {
        post {
          mentions
        }
        question {
          acceptedAnswerId
        }
        answer {
          mentions
        }
      }
    }
  }
  ${CHANGE_EVENT_POST_DETAILS_FRAGMENT}
  ${CHANGE_EVENT_QUESTION_OVERVIEW_FRAGMENT}
  ${CHANGE_EVENT_ANSWER_FRAGMENT}
  ${CHANGE_EVENT_COMMENT_FRAGMENT}
`;
